export default {"src":"/_next/static/media/print.9f8da7b0.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};